import { IHMSDedicatedServer } from '@/types/dedicated.interface'
import { createContext } from 'react'

interface IModal {
  active: boolean
  setActive: (state: boolean) => void
}

interface IMainModals {
  loginModal: IModal
  balanceModal: IModal
  onSelectPlanModal: IModal
  searchPopup: IModal
  orderDedicatedServerModal: IModal & {
    plan?: IHMSDedicatedServer
    setPlan: (plan: IHMSDedicatedServer) => void
  }
}

const MainModalsContext = createContext<IMainModals>({} as IMainModals)

export default MainModalsContext
